var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { EmailTemplateType } from './EmailTemplateType';
export var TemplateTypes;
(function (TemplateTypes) {
    TemplateTypes["received"] = "application.received";
    TemplateTypes["rejected"] = "application.rejected";
    TemplateTypes["processed"] = "application.processed";
    TemplateTypes["interviewed"] = "application.interviewed";
    TemplateTypes["hired"] = "application.hired";
})(TemplateTypes || (TemplateTypes = {}));
export var templateTypeMap = {
    0: TemplateTypes.received,
    2: TemplateTypes.processed,
    3: TemplateTypes.interviewed,
    4: TemplateTypes.hired,
    5: TemplateTypes.rejected,
};
var EmailTemplate = /** @class */ (function (_super) {
    __extends(EmailTemplate, _super);
    function EmailTemplate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.name = null;
        _this.subject = null;
        _this.body = null;
        _this.position = null;
        _this.types = [];
        _this.createdAt = null;
        _this.updatedAt = null;
        _this.groupId = null;
        return _this;
    }
    EmailTemplate.prototype.hasType = function (typeId) {
        return this.types.find(function (emailType) { return emailType.id === typeId; });
    };
    __decorate([
        Type(EmailTemplateType),
        __metadata("design:type", Array)
    ], EmailTemplate.prototype, "types", void 0);
    return EmailTemplate;
}(Entity));
export { EmailTemplate };
